import classnames from "classnames";
import { forwardRef } from "react";
import styles from "./Button.module.scss";

export const SIZE = {
  SMALL: "small",
  MIDDLE: "middle",
  LARGE: "large",
};

export const COLOR = {
  DARK: "dark",
  LIGHT: "light",
  GREY: "grey",
  NONE: "none",
};

export const STYLE = {
  SECONDARY: "secondary",
  INFO: "info",
};

const Button = forwardRef((props, ref) => {
  const {
    type,
    size,
    color = "dark",
    children,
    className,
    disabled,
    onClick,
    style,
  } = props || {};

  return (
    <button
      type={type}
      disabled={disabled}
      className={classnames(
        styles.wrapper,
        className,
        {
          [styles[size]]: size,
        },
        {
          [styles[color]]: color,
        },
        {
          [styles[style]]: style,
        },
      )}
      ref={ref}
      onClick={onClick}
    >
      {children}
    </button>
  );
});

export default Button;
